import React from "react";
import {Alert} from "react-bootstrap";

/**
 * Warnhinweis, der auf allen Kampagnen-Seiten erscheinen soll: Kampagnen
 * verschicken echte, persönliche E-Mails im Namen eines gewählten
 * Absenders - kein Newsletter-Versand.
 */
export default function NoNewsletterBanner() {
    return (
        <Alert variant="danger">
            <strong>Achtung:</strong> Das ist KEIN Newsletter-Versand. Es werden echte,
            persönliche E-Mails im Namen des gewählten Absenders verschickt.
        </Alert>
    );
}
